import { isFunction } from "lodash";

export const getCatchError = (error, callback) => {
    if (error?.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.replace(window.location.origin);
    } else if (error?.response?.data?.message) {
        if (isFunction(callback)) {
            callback(error.response.data.message)
        } else {
            alert(error?.response?.data?.message);
        }
    } else if (error?.response?.message === 'You already have the same free spin campaign for this game') {
        alert('Ошибка! Пользователь еще не отыграл FS в этой игре')
    } else {
        alert('Неизвестная ошибка')
    }
}

